export default __webpack_public_path__ + "static/media/logo.87e3a5cb.svg";